import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { Form, Field } from "react-final-form";
import { Grid } from "@mui/material";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import ContributionPlanPicker from '../../pickers/ContributionPlanPicker';
import InsureePicker from '../../pickers/InsureePicker';
import { useDispatch, useSelector } from 'react-redux';
import DatePickers from '../../pickers/DatePicker';
import { createPolicyHolderInsuree } from '../../action';
import CalendarPicker from '../../pickers/CalenderPicker';

const AddInsureeDialog = ({ showDialog, setShowDialog, setSnackbarMessage }) => {
    const SignInSuccess = useSelector((state) => state);
    const dispatch = useDispatch();
    const [policyHolderId, setPolicyHolderId] = useState();
    const [insureeData, setInsureeData] = useState();
    const { t } = useTranslation()
    useEffect(() => {
        if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
            setPolicyHolderId(SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0].policyHolder)
        }
    }, [policyHolderId, SignInSuccess])

    useEffect(() => {
        setInsureeData(SignInSuccess?.profileReducer?.insureeByIdResponseData);
    }, [SignInSuccess]);
    const handleClose = () => {
        setShowDialog(false);
    };
    const validate = (values) => {
        const errors = {};
        if (!values.insureeNo) {
            errors.insureeNo = t("Field is required");
        }
        if (!values.contributionPlan) {
            errors.contributionPlan = t("Field is required");
        }
        if (!values.income) {
            errors.income = t("Field is required");
        }
        if (!values.validFrom) {
            errors.validFrom = t("Field is required");
        }
        return errors;
    };
    const onSubmit = async (values) => {
        const data = insureeData
        const value = { values, ...data }
        setSnackbarMessage(t("Insuree Successfully add in to policyholder."))
        dispatch(createPolicyHolderInsuree(value, policyHolderId));
    };
    return (
        <React.Fragment>
            <Dialog
                open={showDialog}
            >
                <DialogTitle>{t("Add Policy Holder Insuree")}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item>
                            <Grid container>
                                <Form
                                    onSubmit={onSubmit}
                                    validate={validate}
                                    render={({
                                        handleSubmit,
                                        form,
                                        submitting,
                                        pristine,
                                        values,
                                        errors,
                                    }) => (
                                        // setFormValues(values),
                                        <form onSubmit={handleSubmit}>
                                            <Grid container>
                                                <Grid item xs={12} className="common-input">
                                                    <Field
                                                        name="insureeNo"
                                                        component={InsureePicker}
                                                        label={t("Temporary CAMU No./CAMU No.")}
                                                        required
                                                        type="text"
                                                        insureeNo={values}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} className="common-input">
                                                    <Field
                                                        name="contributionPlan"
                                                        component={ContributionPlanPicker}
                                                        label={t("Contribution Plan Bundle")}
                                                    // type="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} className="common-input" style={{ marginTop: "2px" }}>
                                                    <Field
                                                        name="employeeNo"
                                                        component={TextInput}
                                                        label={t("Employee No.")}
                                                        // required
                                                        type="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} className="common-input">
                                                    <Field
                                                        name="income"
                                                        component={TextInput}
                                                        label="Income"
                                                        required
                                                        type="text"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} className="common-input">
                                                    <Field
                                                        name="validFrom"
                                                        component={CalendarPicker}
                                                        label={t("Created From")}
                                                        onChange={(value) => form.change('validFrom', value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} className="common-input">
                                                    <Field
                                                        name="validTo"
                                                        component={CalendarPicker}
                                                        label={t("Date Valid To")}
                                                        onChange={(value) => form.change('validTo', value)}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <DialogActions>
                                                <Button onClick={handleClose}>{t("cancel")}</Button>

                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    disabled={submitting || pristine || Object.keys(errors).length > 0}
                                                // style={{ width: "100%" }}
                                                // fullWidth
                                                >
                                                    {t("Add")}
                                                </Button>
                                            </DialogActions>
                                        </form>
                                    )}

                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>

            </Dialog>
        </React.Fragment>
    );
}
export default AddInsureeDialog